<template>
    <div class="page-container">
        <!-- 公司介绍 -->
        <div id="home">
          <div class="page-wrapper" style="height:auto; background-image: linear-gradient(to bottom, #ebf8ff, #f5f7fa );">
              <div class="page-content" style="padding:140px 0 60px 0;">
                  <div class="title">关于华翊</div>
                  <div class="intro-text" style="margin-bottom:50px;">广东华翊智能科技有限公司（以下简称“华翊智能”）是一家物联网平台服务商，公司致力于为B端客户提供等全方位数字化产品和集成服务，依托公司多年精益辅导团队基因和数字化能力，通过物联网+云+边缘计算+大数据为手段，以“省钱、省心、省事”为目的，为用户赋能，帮助企业实现数字化转型提供服务。</div>
                  <div style="text-align:center;"><img :src="companyBg" style="width:100%;" /></div>
                  <div style="display:flex; align-items:center; justify-content:space-between; width:80%; margin:0 auto; ">
                      <div
                          v-for="(item, index) in data1"
                          :key="index"
                          style="width:300px; padding:40px; display:flex; flex-direction: column; align-items:center; justify-content:flex-start; "
                      >
                          <div><img :src="item.img" /></div>
                          <div style="font-size:32px; line-height:36px; color:#000; margin:30px 0; border-bottom:4px solid #335CFF; padding-bottom:26px; ">{{  item.title }}</div>
                          <div style="font-size:24px; line-height:36px; color:#525866; ">{{  item.content }}</div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="page-wrapper" style="background-image: linear-gradient(285deg, #335cff, #47c2ff);">
              <div class="page-content" :style="{ backgroundRepeat:'no-repeat', backgroundSize:'contain', backgroundImage:`url(${companyBg2})`, backgroundPosition:'50% 50%' }"></div>
          </div>
          
        </div>
        <!-- 华翊动态 -->
        <LatestNews />
        <!-- 客户案例 -->
        <AllCustomerCase />
        <!-- 合作方式 -->
        <div id="teamwork">
          <CustomModal :visible="visible" @onClose="onClose" />
          <div class="page-wrapper" style="height:auto; background:#fff;">
            <div class="page-content" style="padding-top:50px;">
                <div class="title">合作方式</div>
                <div class="flex-container" style="margin-bottom:100px;">
                    <div
                        v-for="(item, index) in teamworkData1"
                        :key="index"
                        class="flex-item"
                    >
                        <div><img :src="item.img" /></div>
                        <div style="font-size:24px; line-height:34px; color:#333333; ">{{ item.title }}</div>
                    </div>
                </div>
            </div>
          </div>  
          <div class="page-wrapper" style="height:auto; background:#F5F7FA; ">
              <div class="page-content" style="padding:50px 0 150px 0;">
                  <div class="title" style="margin-bottom:50px;">合作优势</div>
                  <div class="flex-container" style="gap:16px;">
                      <div
                          v-for="(item, index) in teamworkData2"
                          :key="index"
                          class="flex-item"
                          style="width:calc( 20% - 13px ); border-top:none; background:#fff; border-radius:12px; box-shadow: 0px 16px 32px -12px rgb(57, 58, 63, 0.15) ;"
                      >
                          <div><img :src="item.img" /></div>
                          <div style="margin:20px 0; font-size:24px; line-height:40px; color:#000; font-weight:bold; ">{{ item.title }}</div>
                          <div style="white-space:pre-line; text-align:center; color:#525866; line-height:24px; ">{{  item.content }}</div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="page-wrapper" style="height:auto; background:#fff; ">
              <div class="page-content" style="padding:50px 0;">
                  <div class="title" style="margin-bottom:50px;">合作流程</div>
                  <div style="display:flex; align-items:center; justify-content:space-between; width:86%; margin:0 auto; ">
                      <div
                          v-for="(item, index) in teamworkData3"
                          :key="index"
                          style="display:flex; align-items:flex-start; justify-content:space-between;"
                      >
                          <div style="margin-right:16px;"><img :src="item.img" /></div>
                          <div>
                              <div style="font-size:36px; line-height:50px; color:#335CFF; font-weight:bold; ">{{ '0' + ( index + 1 ) }}</div>
                              <div style="font-size:20px; line-height:20px; color:#525866; font-weight:bold; ">{{  item.title }}</div>
                          </div>
                          <div v-if="index !== teamworkData3.length-1 " style="align-self:center; margin-left:60px;"><img :src="arrowIcon" /> </div>
                      </div>
                  </div>
                  <div style="margin:50px 0 30px 0; text-align:center; "><el-button type="primary" size="large" color="#335CFF" @click="visible=true">立即申请</el-button></div>
                  <div style="font-size:16px; color:#525866; font-weight:bold; line-height:28px; text-align:center;">渠道合作电话咨询: 13923654388</div>
              </div>
          </div>
        </div>
        <!-- 公司地址 -->
        <div class="page-wrapper" style="background:#F5F7FA; height:auto; text-align:center;  ">
          <div class="page-content" style="padding:80px 0;"><img :src="companyBg3" style="width:1055px;" />
        </div>
    </div>
  </div>
</template>

<script>
  import { markAction } from '@/api/global.js';
  import bgImg from '@/assets/home-bg.jpg';
  import bgLogo from '@/assets/home-bg-logo.png';
  import HoverUnfold from './HoverUnfold.vue';
  import AIContent1 from './AIContent1.vue';
  import AIContent2 from './AIContent2.vue';
  import FollowSlider from '@/components/FollowSlider/index.vue';
  import CaseContent from './CaseContent.vue';
  import AllCustomerCase from './AllCustomerCase.vue';
  import LatestNews from './LatestNews.vue';
  import Bg from '@/assets/motion-bg.png';
  import companyBg from '@/assets/about-icon-1.png';
  import companyBg2 from '@/assets/about-icon-5.png';
  import companyBg3 from '@/assets/about-icon-7.png';
  import Icon2 from '@/assets/about-icon-2.png';
  import Icon3 from '@/assets/about-icon-3.png';
  import Icon4 from '@/assets/about-icon-4.png';
  import Icon5 from '@/assets/about-icon-5.png';
  import Icon6 from '@/assets/about-icon-6.png';
  import teamworkIcon1 from '@/assets/teamwork-icon-1.png';
  import teamworkIcon2 from '@/assets/teamwork-icon-2.png';
  import teamworkIcon3 from '@/assets/teamwork-icon-3.png';
  import teamworkIcon4 from '@/assets/teamwork-icon-4.png';
  import teamworkIcon5 from '@/assets/teamwork-icon-5.png';
  import teamworkIcon6 from '@/assets/teamwork-icon-6.png';
  import teamworkIcon7 from '@/assets/teamwork-icon-7.png';
  import teamworkIcon8 from '@/assets/teamwork-icon-8.png';
  import teamworkIcon9 from '@/assets/teamwork-icon-9.png';
  import teamworkIcon10 from '@/assets/teamwork-icon-10.png';
  import teamworkIcon11 from '@/assets/teamwork-icon-11.png';
  import teamworkIcon12 from '@/assets/teamwork-icon-12.png';
  import teamworkIcon13 from '@/assets/teamwork-icon-13.png';
  import arrowIcon from '@/assets/teamwork-icon-arrow.png';
  import CustomModal from '@/components/CustomModal.vue';


  const teamworkData1 = [{ title:'项目合作', img:teamworkIcon1 }, { title:'商情转介', img:teamworkIcon2 }, { title:'产品合作', img:teamworkIcon3 }, { title:'定制开发', img:teamworkIcon4 }];
  const teamworkData2 = [
      { title:'丰厚返利', img:teamworkIcon5, content:'高回报返利体系\n高续费比例带来稳定营收\n季/年度优秀代理商激励' },
      { title:'体系化培训', img:teamworkIcon6, content:'定期线上产品培训\n定期线下训练营\n渠道经理定期走访辅导' },
      { title:'服务支持', img:teamworkIcon7, content:'7*12小时在线人工客服\n 1对1沟通\n专属客户沟通服务群'},
      { title:'市场支持', img:teamworkIcon8, content:'产品画册、折页等物料\n项目方案支持\n拓客话术等销售资料'},
      { title:'驻地支持', img:teamworkIcon9, content:'线下交流和沙龙\n运营能力培训服务\n市场销售培训服务'}
  ];
  const teamworkData3 = [ { title:'提交申请', img:teamworkIcon10 }, { title:'审核资料', img:teamworkIcon11 }, { title:'洽谈合作', img:teamworkIcon12 }, { title:'签约合作', img:teamworkIcon13 } ];
  
  export default {
      data(){
        return {
          bgImg,
          bgLogo,
          Bg,
          data1:[
            { title:'愿景', img:Icon2, content:'联接人与物、物与物人与人，让管理更简单、更安全、更高效' },
            { title:'使命', img:Icon3, content:'深耕工业物联网行业为工商业用户创造价值。' },
            { title:'价值观', img:Icon4, content:'客户至上，挑战自我, 认真生活。'}
          ],
          companyBg,
          companyBg2,
          companyBg3,
          teamworkData1,
          teamworkData2,
          teamworkData3,
          arrowIcon,
          visible:false
        }
      },
      methods:{
          handleClick(){
            markAction({ operationType:'进入厂务' });
            window.open('http://iot.ifmcs.com', '__blank');
          },
          onClose(){
              this.visible = false;
          }
      },
      components:{
        HoverUnfold,
        FollowSlider,
        AIContent1,
        AIContent2,
        CaseContent,
        AllCustomerCase,
        LatestNews,
        CustomModal
      },
      watch:{
        '$route.query.pos':{
          immediate:true,
          handler:function(newVal){
              if ( this.$route.query.pos ) {
                  let ele = document.getElementsByClassName('ps')[0];
                  if ( ele ) {
                    ele.scrollTop = window.innerHeight + Number(this.$route.query.pos)
                  }
              }
          }
        }
      }
  }

</script>

<style>
  .intro-text {
    font-size:24px;
    line-height:36px;
    color:#525866;
    font-weight:lighter;
  }
  .flex-container {
      display:flex;
      flex-wrap:wrap; 
      gap:24px; 
  }
  .flex-container .flex-item {
      display:flex;
      flex-direction:column;
      justify-content:center;
      align-items:center;
      width:calc( 25% - 18px );
      height:327px;
      background:#f5f7fa;
      border-radius:8px;
      border-top:8px solid #3471ff;
    
  }
  .motion-bg {
      position:absolute;
      width:100%;
      top:0;
      animation: float 40s ease-out infinite;
  }
  @keyframes float {
      0%{
          transform:translateY(0);
      }
      /* 25% {
          transform:translate(-80%, -50%);
      } */
      50%{
          transform:translateY(-400px);
      }
      
      100%{
          transform:translateY(0);
      }
  }
</style>

